// extracted by mini-css-extract-plugin
export default {"isContainer":"quote_isContainer__UNjAD","body":"quote_body__1J-5Q","quote":"quote_quote__JWp78","author":"quote_author__19ERs"};